import { inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { injectMutation, QueryClient } from '@tanstack/angular-query-experimental';
import { CreateUserRequest, UserService } from '../../../../../../api';
import { QueryKey } from '../../../../../constants/query-key';

@Injectable()
export class UserCommandService {
  private readonly userService = inject(UserService);
  private readonly queryClient = inject(QueryClient);

  createMutation = injectMutation(() => ({
    mutationFn: (request: CreateUserRequest) =>
      lastValueFrom(this.userService.createUser(request)),
    onSuccess: () => {
      this.queryClient.invalidateQueries({ queryKey: [QueryKey.USERS] });
    },
  }));

  deleteMutation = injectMutation(() => ({
    mutationFn: (id: number) => lastValueFrom(this.userService.deleteUser(id)),
    onSuccess: () => {
      this.queryClient.invalidateQueries({ queryKey: [QueryKey.USERS] });
    },
  }));
}
